import React from 'react';

const GoogleRatingStars = ({ stars }) => {
  const fillColor = (starPosition) =>
    starPosition <= stars ? '#FBBC04' : '#DADCE0';
  return (
    <svg
      width="151"
      height="25"
      viewBox="0 0 151 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6472 19.7376L20.4535 24.4492L18.3819 15.5692L25.2788 9.59448L16.1967 8.82396L12.6472 0.449219L9.09773 8.82396L0.015625 9.59448L6.91247 15.5692L4.84089 24.4492L12.6472 19.7376Z"
        fill={fillColor(1)}
      />
      <path
        d="M43.9128 19.7376L51.7191 24.4492L49.6476 15.5692L56.5444 9.59448L47.4623 8.82396L43.9128 0.449219L40.3634 8.82396L31.2812 9.59448L38.1781 15.5692L36.1065 24.4492L43.9128 19.7376Z"
        fill={fillColor(2)}
      />
      <path
        d="M75.1706 19.7376L82.977 24.4492L80.9054 15.5692L87.8022 9.59448L78.7201 8.82396L75.1706 0.449219L71.6212 8.82396L62.5391 9.59448L69.4359 15.5692L67.3643 24.4492L75.1706 19.7376Z"
        fill={fillColor(3)}
      />
      <path
        d="M106.436 19.7376L114.243 24.4492L112.171 15.5692L119.068 9.59448L109.986 8.82396L106.436 0.449219L102.887 8.82396L93.8047 9.59448L100.702 15.5692L98.63 24.4492L106.436 19.7376Z"
        fill={fillColor(4)}
      />
      <path
        d="M137.702 19.7376L145.508 24.4492L143.437 15.5692L150.333 9.59448L141.251 8.82396L137.702 0.449219L134.152 8.82396L125.07 9.59448L131.967 15.5692L129.896 24.4492L137.702 19.7376Z"
        fill={fillColor(5)}
      />
    </svg>
  );
};

GoogleRatingStars.displayName = 'GoogleRatingStars';
export default GoogleRatingStars;
